// logout.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeycloakAuthService } from '@app/core/services/keycloak-auth.service';

@Component({
  standalone: true,
  selector: 'app-logout',
  imports: [CommonModule],
  template: `
    <button
      (click)="logout()"
      class="text-sm font-medium text-red-600 px-3 py-1.5 sm:px-4 sm:py-2 border border-red-600 rounded hover:bg-red-600 hover:text-white transition-colors flex items-center"
    >
      <!-- Mobile/Tablet: Logout icon (arrow exiting box) -->
      <svg class="w-5 h-5 sm:hidden" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
      </svg>
      <!-- Desktop: Text only -->
      <span class="hidden sm:inline">Logout</span>
    </button>
  `
})
export class LogoutComponent {
  private isLoggingOut = false;

  constructor(private keycloakAuthService: KeycloakAuthService) {}

  async logout(): Promise<void> {
    if (this.isLoggingOut) {
      return;
    }

    this.isLoggingOut = true;

    try {
      await this.keycloakAuthService.logout();
    } catch (error) {
      console.error('[Logout] Error:', error);
      window.location.href = window.location.origin;
    } finally {
      this.isLoggingOut = false;
    }
  }
}
